<template>
  <vue-content-loading :width="300" :height="160">
    <rect v-bind="calendarAttributes" x="0" y="0" />

    <template v-if="$vuetify.breakpoint.xsOnly">
      <rect v-bind="timeSlotAttributesMobile" x="0" y="105" />
      <rect v-bind="timeSlotAttributesMobile" x="0" y="130" />
    </template>
    <template v-else>
      <rect v-bind="timeSlotAttributes" x="30" y="110" />
      <rect v-bind="timeSlotAttributes" x="110" y="110" />
      <rect v-bind="timeSlotAttributes" x="190" y="110" />

      <rect v-bind="timeSlotAttributes" x="30" y="130" />
      <rect v-bind="timeSlotAttributes" x="110" y="130" />
      <rect v-bind="timeSlotAttributes" x="190" y="130" />
    </template>
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
  data() {
    return {
      borderRadius: 4,
      calendarHeight: 100,
      calendarWidth: 300,
      timeSlotHeight: 15,
      timeSlotWidth: 75,
    };
  },
  computed: {
    borderRadiusAttributes() {
      return {
        rx: this.borderRadius,
        ry: this.borderRadius,
      };
    },
    calendarAttributes() {
      return {
        ...this.borderRadiusAttributes,
        height: this.calendarHeight,
        width: this.calendarWidth,
      };
    },
    timeSlotAttributes() {
      return {
        ...this.borderRadiusAttributes,
        height: this.timeSlotHeight,
        width: this.timeSlotWidth,
      };
    },
    timeSlotAttributesMobile() {
      const mobileMultiplier = 1.5;
      return {
        ...this.borderRadiusAttributes,
        height: this.timeSlotHeight * mobileMultiplier,
        width: this.calendarWidth,
      };
    },
  },
};
</script>
